import { useCallback, useEffect, useRef, useState } from 'react'
import { Icon } from '@iconify/react'
import {
  useDeleteTableState,
  useGetTableFilterState,
  usePostTableFilterState,
} from '../api/tableStateApi'
import _ from 'lodash'
import { ShowInfoPopover } from './InfoPopover'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import { useInvalidateAllCacheMutation } from '../generated/graphql'
import { graphqlRequestClient } from '../queries/client'
import { RefetchUserContext } from './RefetchUserContext'

export interface FilterConditionModel {
  isFilterSave: boolean
  isColumnSave: boolean
}

interface SyncDataIconProps {
  tableId: string
  isLoading: boolean
  setFilterCondition: (func: any) => void
}

const SyncDataIcon: React.FC<SyncDataIconProps> = ({ tableId, isLoading, setFilterCondition }) => {
  const clearCache = useInvalidateAllCacheMutation(graphqlRequestClient, {
    onSuccess: () => {},
  })

  const handleClearAllStates = (): void => {
    clearCache.mutate(
      {},
      {
        onSuccess: async () => {
          await RefetchUserContext()
          window.location.reload()
        },
      }
    )
  }

  // // Debounced function
  // const debouncedSearch = useCallback(
  //   _.debounce((isColumnSave: boolean, isFilterSave: boolean) => {
  //     postOnFilter.mutate({
  //       tableId: tableId,
  //       companyId: '',
  //       filterData: {
  //         isColumnSave,
  //         isFilterSave,
  //         filterState: tableState?.filterState,
  //         columnState: tableState?.columnState,
  //       },
  //     })
  //   }, 300),
  //   [filterCondition, tableState]
  // )

  return (
    <div className='position-relative'>
      <OverlayTrigger
        trigger={['hover', 'focus']}
        placement='bottom'
        rootCloseEvent='mousedown'
        overlay={HelpingPopover()}
      >
        <span
          style={{
            cursor: 'pointer',
          }}
        >
          <Icon
            icon='ic:twotone-sync'
            className='text-gray-600 text-hover-primary mt-2'
            width='28'
            height='28'
            onClick={() => handleClearAllStates()}
          />
        </span>
      </OverlayTrigger>
    </div>
  )
}

const HelpingPopover = () => (
  <Popover id='popover-basic' className='min-w-300px mt-2'>
    <Popover.Body className='p-0'>
      <div className='text-justify'>
        <div
          className='p-3 d-flex align-items-center gap-2 rounded'
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
        >
          <Icon
            icon='hugeicons:database-sync-01'
            className='text-white text-hover-primary'
            width='28'
            height='28'
          />
          <div>
            <h4 className='text-white fw-bold mb-0'>Sync Data</h4>
            <p className='text-white small mb-0'>Click here to sync portfolio with updated data.</p>
          </div>
        </div>
      </div>
    </Popover.Body>
  </Popover>
)

export default SyncDataIcon
